@if (sizeAttribute && sizeAttribute.code && sizeAttribute.options.length && stocks.length) {
<div class="pos-absolute top-4 left-4 z-10 p-a bg-col-w-75 box-shadow">
    <p class="p2 col-11 m-b-1">{{ sizeAttribute.code | attributeLabel }}</p>
    @for (stock of stocks; track $index) {
    <p class="m-t-2 c1">{{ stock.label }}: {{ stock.qty || 0 }}</p>
    }
</div>
}